﻿import { ValidationService } from 'aspnet-client-validation';

export default { ValidationService };
